import {
  ColumnHeightOutlined,
  DownloadOutlined,
  ImportOutlined,
  PlusOutlined,
  SettingOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Button, Checkbox, Dropdown, Radio, Space, Tooltip } from 'antd';
import React, { useState } from 'react';
import ImportModal from '../AppModal/ImportModal';

const TableTitle = ({
  tableTitle,
  onCreate,
  onRefresh,
  onExport,
  exportTooltip = 'Export',
  hasImport = false,
  isLoading = false,
  columnKeys = [],
  visibleColumns = [],
  disableColumnVisibility = false,
  onColumnChange,
  rowHeight = 'middle',
  onSizeChange,
}) => {
  const [openSettings, setOpenSettings] = useState(false);
  const [openSize, setOpenSize] = useState(false);
  const [openImport, setOpenImport] = useState(false);

  const menu = (
    <div className="p-3 bg-white shadow-lg rounded-md">
      <Checkbox.Group
        options={columnKeys?.map((col) => ({ label: col.label, value: col.value }))}
        value={visibleColumns}
        onChange={onColumnChange}
        className="flex flex-col gap-2"
      />
    </div>
  );

  const sizeMenu = (
    <div className="p-3 bg-white shadow-lg rounded-md">
      <Radio.Group
        value={rowHeight}
        onChange={(e) => {
          onSizeChange?.(e.target.value);
        }}
        buttonStyle="solid"
      >
        <Radio.Button value="small">Small</Radio.Button>
        <Radio.Button value="middle">Medium</Radio.Button>
        <Radio.Button value="large">Large</Radio.Button>
      </Radio.Group>
    </div>
  );

  return (
    <>
      <Space className={`flex items-center ${tableTitle ? 'justify-between' : 'justify-end'}`}>
        {tableTitle}
        <Space className="flex items-center justify-end">
          {onCreate && (
            <Tooltip title="Create new">
              <Button onClick={onCreate} type="text" className="px-2">
                <PlusOutlined />
              </Button>
            </Tooltip>
          )}
          {hasImport && (
            <Tooltip title="Import">
              <Button
                onClick={() => setOpenImport(true)}
                type="text"
                className="px-2"
                disabled={isLoading}
              >
                <ImportOutlined />
              </Button>
            </Tooltip>
          )}
          {onExport && (
            <Tooltip title={exportTooltip}>
              <Button
                type="text"
                onClick={onExport}
                className="flex items-center px-2"
                disabled={isLoading}
              >
                <DownloadOutlined />
              </Button>
            </Tooltip>
          )}
          {onRefresh && (
            <Tooltip title="Refresh">
              <Button onClick={onRefresh} type="text" disabled={isLoading} className="px-2">
                <SyncOutlined spin={isLoading} />
              </Button>
            </Tooltip>
          )}
          <Tooltip title={`Size: ${rowHeight === 'middle' ? 'Medium' : rowHeight}`}>
            <Dropdown
              open={openSize}
              onOpenChange={setOpenSize}
              trigger={['click']}
              dropdownRender={() => sizeMenu}
              arrow
            >
              <Button
                type="text"
                onClick={() => setOpenSize(!openSize)}
                disabled={isLoading}
                className="px-2"
              >
                <ColumnHeightOutlined />
              </Button>
            </Dropdown>
          </Tooltip>
          {columnKeys.length > 1 && !disableColumnVisibility && (
            <Tooltip title="View settings">
              <Dropdown
                open={openSettings}
                onOpenChange={setOpenSettings}
                trigger={['click']}
                dropdownRender={() => menu}
                arrow
              >
                <Button
                  type="text"
                  onClick={() => setOpenSettings(!openSettings)}
                  disabled={isLoading}
                  className="px-2"
                >
                  <SettingOutlined />
                </Button>
              </Dropdown>
            </Tooltip>
          )}
        </Space>
      </Space>

      <ImportModal open={openImport} setOpen={setOpenImport} />
    </>
  );
};

export default TableTitle;
